import { AfterViewInit, Component, Input } from "@angular/core";
import { EdiMessageGridLineItemData } from "@interfaces/data/ediMessageGridLineItemData";

@Component({
	moduleId: module.id,
	selector: "ediMessageGridDetails",
	styleUrls: ["ediMessageGridDetails.css"],
	templateUrl: "ediMessageGridDetails.html"
})
export class EdiMessageGridDetailsComponent implements AfterViewInit {
	@Input() lineItemData = "";
	lineItems: EdiMessageGridLineItemData[] = [];
  
	ngAfterViewInit() {
		this.lineItems = JSON.parse(this.lineItemData);
	}
}